
const baseGeneralUrl = "General"

  const endpoints = {
   getPageById:`${baseGeneralUrl}/GetPageItemById`,
  
  };
  
  export default endpoints;